import React from 'react'
import Image from "next/image";
import Head from "next/head";
import styles from "./tnpsc-enrischment-program.module.css";
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Webbanner from "../../assets/images/Tnpsc/Tnpsc-Enrichment-Test-Series-Web-Banner.jpg";
import Mobbanner from "../../assets/images/Tnpsc/Tnpsc-Enrichment-Test-Series-Mobile-Banner.jpg";

import Link from 'next/link';

 const feestructure3 = [
  {
    center: "Anna Nagar",

    fee: {
      new: "₹3,500",
    //   old: "₹6,500",
    },

    batches: [
      {
        batch: "Batch I - General English Offline",
        start: "07-06-2026",
        schedule:
          "https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-Enrichment-TestSeries-2026/Anna-nagar/Tnpsc-Enrichment-GE-B1.pdf",
        admission:
          "https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=TNPSC",
      },

      {
        batch: "Batch I - General English Online",
        start: "07-06-2026",
        schedule:
          "https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-Enrichment-TestSeries-2026/Anna-nagar/Tnpsc-Enrichment-GE-B1.pdf",
        admission:
          "https://admissionsv1.shankariasacademy.com/?center=ONLINE TEST BATCH&coursetype=TNPSC",
      },

      {
        batch: "Batch II - General Tamil Offline",
        start: "07-06-2026",
        schedule:
         "https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-Enrichment-TestSeries-2026/Anna-nagar/Tnpsc-Enrichment-GT-B2.pdf",
        admission:
          "https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=TNPSC",
      },

      {
        batch: "Batch II - General Tamil Online",
        start: "07-06-2026",
        schedule:
          "https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-Enrichment-TestSeries-2026/Anna-nagar/Tnpsc-Enrichment-GT-B2.pdf",
        admission:
          "https://admissionsv1.shankariasacademy.com/?center=ONLINE TEST BATCH&coursetype=TNPSC",
      },

      
    ],
  },

  {
    center: "Madurai",

    fee: {
      new: "₹3,500",
    },

    batches: [
      {
        batch: "Batch I - General English Offline",
        start: "12-06-2026",
        schedule: "https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-Enrichment-TestSeries-2026/Madurai/Tnpsc-Enrichment-GE-B1-Madurai.pdf",
        admission: "https://admissionsv1.shankariasacademy.com/?center=Madurai&coursetype=TNPSC",
      },

      {
        batch: "Batch II - General Tamil Offline",
        start: "12-06-2026",
        schedule: "https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-Enrichment-TestSeries-2026/Madurai/Tnpsc-Enrichment-GT-B2-Madurai.pdf",
        admission: "https://admissionsv1.shankariasacademy.com/?center=Madurai&coursetype=TNPSC",
        
      },
    ],
  },

   {
    center: "Coimbatore",

    fee: {
      new: "₹3,500",
    },

    batches: [
      {
        batch: "Batch I - General English Offline",
        start: "14-06-2026",
        schedule: "https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-Enrichment-TestSeries-2026/Covai/Tnpsc-Enrichment-GE-B1-Covai.pdf",
        admission: "https://admissionsv1.shankariasacademy.com/?center=covai&coursetype=TNPSC",
      },

      {
        batch: "Batch II - General Tamil Offline",
        start: "14-06-2026",
        schedule: "https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-Enrichment-TestSeries-2026/Covai/Tnpsc-Enrichment-GT-B2-Covai.pdf",
        admission: "https://admissionsv1.shankariasacademy.com/?center=covai&coursetype=TNPSC",
        
      },
    ],
  },
];


const TnpscWorkshop = () => {
    return (
        <>

        <Head>
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>TNPSC Enrichment Test Series | General Tamil & General English</title>
            <meta name="title" content="TNPSC  Enrichment Test Series | General Tamil & General English" />
            <meta name="description" content="Join the TNPSC  Enrichment Test Series for General Tamil and General English at Shankar IAS Academy. Practice with updated mock tests, improve accuracy, and strengthen your TNPSC exam preparation. Enroll now for success!" />
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-general-enrichment-test-series/ " />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="TNPSC  Enrichment Test Series | General Tamil & General English" />
            <meta property="og:description" content="Join the TNPSC General Enrichment Test Series for General Tamil and General English at Shankar IAS Academy. Practice with updated mock tests, improve accuracy, and strengthen your TNPSC exam preparation. Enroll now for success!" />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-general-enrichment-test-series/ " />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

            <Navbar title="upsc" />

            <div className="container">
                <div className="pt-3 pt-md-4">
                    <h1 className={`${styles.pagemaintitle}`}> I'M TOP TNPSC GT & GE Enrichment Test Series  - 2026</h1>
                </div>

                <div className="row d-none d-md-block">
                    <div className="col pt-2 mb-3">
                        <Image src={Webbanner} alt="tnpsc-group-II-mains-test-series banner" title="TNPSC Group II/II-A Mains 2022 New Test Series" className="img-fluid w-100" />
                    </div>
                </div> 

                <div className="row  d-block d-md-none">
                    <div className="col pt-2 mb-3">
                        <Image src={Mobbanner} alt="tnpsc-group-II-mains-test-series banner" title="TNPSC Group II/II-A Mains 2022 New Test Series" className="img-fluid w-100" />
                    </div>
                </div>
            </div> 
          

            <section className={styles.courseSection}>
                <div className="container">
                    <div className={styles.headingBox}>
                       <h2> I'M TOP TNPSC Enrichment Test Series</h2>
                       <span> General Tamil & General English</span>
                    </div>

                    <div className={`${styles.tableWrapper} d-none d-md-block`}>
                        <table className={styles.courseTable}>
                            <thead>
                                <tr>
                                <th>Center</th>
                                <th>Batch</th>
                                <th>Starts On</th>
                                <th>Fee</th>
                                <th>Schedule</th>
                                <th>Admission</th>
                                </tr>
                            </thead>

                            <tbody >
                            {feestructure3.map((centerItem) =>
                                centerItem.batches.map((batch, index) => (
                                    <tr key={index}>

                                    {/* Center Common */}
                                    {index === 0 && (
                                        <td rowSpan={centerItem.batches.length}>
                                        {centerItem.center}
                                        </td>
                                    )}

                                    {/* Batch */}
                                    <td>{batch.batch}</td>

                                    {/* Start */}
                                    <td>{batch.start}</td>

                                    {/* Fee Separate */}
                                    <td>
                                        <div>{centerItem.fee.new}</div>
                                    </td>

                                    {/* Schedule */}
                                    <td>
                                        {batch.schedule !== "#" ? (
                                        <a href={batch.schedule} target="_blank">
                                            <i className="bi bi-file-earmark-pdf-fill me-2"></i>
                                            View Pdf
                                        </a>
                                        ) : (
                                        <span>Update Soon</span>
                                        )}
                                    </td>

                                    {/* Admission */}
                                    <td>
                                        <a href={batch.admission} target="_blank">
                                        <button className={styles.payBtn}>
                                            Pay Now
                                        </button>
                                        </a>
                                    </td>

                                    </tr>
                                ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div  className={`${styles.mobileView} d-block d-md-none`}>
                            {feestructure3.map((centerItem, centerIndex) =>
                                centerItem.batches.map((batch, index) => (
                                <div className={styles.card} key={index}>
                                    
                                    <div className={styles.row}>
                                    <span>Center</span>
                                    <strong>{centerItem.center}</strong>
                                    </div>

                                    <div className={styles.row}>
                                    {/* <span>Batch</span> */}
                                    <strong>{batch.batch}</strong>
                                    </div>

                                    <div className={styles.row}>
                                    <span>Start Date</span>
                                    <strong>{batch.start}</strong>
                                    </div>

                                    <div className={styles.row}>
                                    <span>Fee</span>
                                    <strong>{centerItem.fee.new}</strong>
                                    </div>

                                    {/* <div className={styles.row}>
                                    <span>Old Fee</span>
                                    <small>{centerItem.fee.old}</small>
                                    </div> */}

                                    <div className={styles.actions}>
                                    <span>Schedule</span>

                                    {batch.schedule !== "#" ? (
                                            <a href={batch.schedule} target="_blank">
                                            View
                                            </a>
                                        ) : (
                                            <span>Update Soon</span>
                                        )}
                                    </div>

                                    <div className={styles.actions}>
                                        <a href={batch.admission} target="_blank">
                                            <button className={styles.payBtn}>
                                            Pay Now
                                            </button>
                                        </a>
                                    </div>

                                </div>
                                ))
                            )}
                    </div>
                </div>
            </section>	

            <Footer />
        </>
    )
}

export default TnpscWorkshop;
